import React from "react";
import {injectIntl} from "react-intl";

import CheckBox from "../../../PageLayout/CheckBox";

const showMatchAllCheckboxFor = [
  "Countertop", "Center Island Countertop", "Backsplash", "Edge Profile",
  "Top Cabinet", "Bottom Cabinet", "Center Island Cabinet", "Fridge Enclosure", "Tall Cabinet",
  "Vanity", "Vanitie", "Mirror",
  "Door Handle", "Drawer Handle",
  "Shower Floor", "Shower Curb",
];

const WizardPopupEditGroupMatchAllCheckbox = (props) => {

  const {intl, wizardPopupGroup, changeInputValue, matchAllDisabled} = props;

  if (!showMatchAllCheckboxFor.includes(wizardPopupGroup.groupName)) {
    return null
  }

  return (
    <CheckBox type={"tiny"}
              checked={!matchAllDisabled}
              text={intl.formatMessage({id: "wizard.popup.matchAllDisabled"})}
              onChecked={() => changeInputValue("matchAllDisabled", !matchAllDisabled)} />
  )
};

export default injectIntl(WizardPopupEditGroupMatchAllCheckbox)
